var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 20.5742V25.1947C1.6665 27.4246 3.35885 29.2905 5.5782 29.5074L5.99984 29.5486L13.5832 30.29L28.4851 31.7469C25.0561 31.0714 22.4046 26.5174 22.4046 21C22.4046 16.1624 24.443 12.0654 27.2566 10.6739L9.24984 15.2719L4.92773 16.3756C3.00898 16.8655 1.6665 18.5939 1.6665 20.5742Z",
    fill: "#42DDD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3689 31.8333C33.2152 31.8333 36.3332 26.9831 36.3332 21C36.3332 15.0169 33.2152 10.1667 29.3689 10.1667C28.6325 10.1667 27.9228 10.3445 27.2566 10.6739M29.3689 31.8333L28.4851 31.7469M29.3689 31.8333C29.0695 31.8333 28.7745 31.8039 28.4851 31.7469M27.2566 10.6739C24.443 12.0654 22.4046 16.1624 22.4046 21C22.4046 26.5174 25.0561 31.0714 28.4851 31.7469M27.2566 10.6739L9.24984 15.2719M5.99984 29.5486L5.5782 29.5074C3.35885 29.2905 1.6665 27.4246 1.6665 25.1947V20.5742C1.6665 18.5939 3.00898 16.8655 4.92773 16.3756L9.24984 15.2719M5.99984 29.5486L7.68659 37.2309C7.97648 38.5512 9.0405 39.5623 10.3739 39.7846C12.5317 40.1442 14.4381 38.3478 14.2073 36.1724L13.5832 30.29M5.99984 29.5486L13.5832 30.29M13.5832 30.29L28.4851 31.7469M9.24984 15.2719V9.08333M12.4998 4.75C12.4998 6.54492 11.0448 8 9.24984 8C7.45491 8 5.99984 6.54492 5.99984 4.75C5.99984 2.95507 7.45491 1.5 9.24984 1.5C11.0448 1.5 12.4998 2.95507 12.4998 4.75Z",
    stroke: "#021744",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.51a4b138271d246d9699ae331e49e6e6.svg";
export { ForwardRef as ReactComponent };